import { BrowserModule } from '@angular/platform-browser';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule, APP_INITIALIZER } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';
import { routing } from './app.routing';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { PaginationModule, TypeaheadModule } from 'ngx-bootstrap';

import ApolloClient, { createNetworkInterface } from 'apollo-client';
import { ApolloModule } from 'apollo-angular';

import { AppComponent } from './app.component';
import { DashboardComponent } from './dashboard/main-dashboard/dashboard.component';
import { SidebarComponent } from './sidebar/sidebar.component';

import { MobileNavComponent } from './mobile-nav/mobile-nav.component';

import { SearchService } from './common/services/search.service';
import { GaService } from './common/services/ga.service';

import { CapitalizePipe } from './common/pipes/capitalize.pipe';

import { StoreModule } from '@ngrx/store';
import { searchState } from './search/reducers/search-state';

import { FooterComponent } from './footer/footer.component';
import { QuickSearchComponent } from './search/quick-search/quick-search.component';
import { SearchComponent } from './search/search/search.component';
import { SearchBarComponent } from './search/search-bar/search-bar.component';
import { MobileSearchResultsComponent } from './search/mobile-search-results/mobile-search-results.component';
import { DesktopSearchResultsComponent } from './search/desktop-search-results/desktop-search-results.component';
import { AdvancedSearchComponent } from './search/advanced-search/advanced-search.component';
import { HospitalProfileComponent } from './profile/hospital-profile/hospital-profile.component';
import { SystemProfileComponent } from './profile/system-profile/system-profile.component';
import { AddressComponent } from './profile/panels/address/address.component';
import { AffHospitalsComponent } from './profile/panels/aff-hospitals/aff-hospitals.component';
import { CSuiteComponent } from './profile/panels/c-suite/c-suite.component';
import { FacilityCodesComponent } from './profile/panels/facility-codes/facility-codes.component';
import { GeneralInfoComponent } from './profile/panels/general-info/general-info.component';
import { GeneralSystemInfoComponent } from './profile/panels/general-system-info/general-system-info.component';
import { UtilizationComponent } from './profile/panels/utilization/utilization.component';
import { OrderByPipe } from './common/pipes/order-by.pipe';
import { SearchFilterPipe } from './common/pipes/search-filter.pipe';
import { SpinnerComponent } from './common/other/spinner/spinner.component';
import { ScriptLoaderService } from './common/services/script-loader.service';
import { GlossaryComponent } from './glossary/glossary.component';
import { ProfileMapComponent } from './profile-map/profile-map.component';
import { StatsDashboardComponent } from './dashboard/stats-dashboard/stats-dashboard.component';
import { UrlEnvService } from './common/services/url-env.service';
import { JwtService } from './common/services/jwt.service';

export function initJwtService(jwtService: JwtService): () => Promise<void> {
  return () => new Promise<void>((resolve) => {
    jwtService.init();
    resolve();
  });
}

const networkInterface = createNetworkInterface({
  uri: '/guide/graphql',
  opts: {
    credentials: 'same-origin'
  }
});

const client = new ApolloClient({
  networkInterface
});

export function provideClient(): ApolloClient {
  return client;
}

@NgModule({
  declarations: [
    HospitalProfileComponent,
    SystemProfileComponent,
    AddressComponent,
    AffHospitalsComponent,
    CSuiteComponent,
    FacilityCodesComponent,
    GeneralInfoComponent,
    GeneralSystemInfoComponent,
    UtilizationComponent,
    AppComponent,
    DashboardComponent,
    SidebarComponent,
    QuickSearchComponent,
    CapitalizePipe,
    OrderByPipe,
    SearchFilterPipe,
    MobileNavComponent,
    FooterComponent,
    SearchComponent,
    SearchBarComponent,
    MobileSearchResultsComponent,
    DesktopSearchResultsComponent,
    AdvancedSearchComponent,
    SpinnerComponent,
    GlossaryComponent,
    ProfileMapComponent,
    StatsDashboardComponent
  ],
  imports: [
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    HttpModule,
    routing,
    PaginationModule.forRoot(),
    TypeaheadModule.forRoot(),
    BsDropdownModule.forRoot(),
    ApolloModule.forRoot(provideClient),
    StoreModule.provideStore({ searchState: searchState })
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  providers: [GaService, SearchService, ScriptLoaderService, UrlEnvService, JwtService, {
    provide: APP_INITIALIZER,
    useFactory: initJwtService,
    deps: [JwtService],
    multi: true
  }],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts